/* @flow */

import dayjs from 'dayjs';
import {
  compact,
} from 'lodash/fp';

import {
  laterTodayDelayMinutesSelector,
  startMorningsAtSelector,
  startEveningsAtSelector,
  lastPostponedDateSelector,
} from '../settings/selectors';
import l from '../../utils/localization';


type PostponeOption = {
  text: string,
  icon: string,
  resolve: () => ?dayjs
}

export const postponeOptionsSelector = (
  state: AppState,
): Array<PostponeOption> => {
  const now = dayjs(),
        lastPostponedDate = lastPostponedDateSelector(state);

  const entries = compact([
    {
      text: l.cancel,
      icon: 'ban',
    },
    now.hour() < 24 - Math.ceil(laterTodayDelayMinutesSelector(state) / 60) && {
      text: l.laterToday,
      icon: 'coffee',
      resolve: () => dayjs().startOf('hour').add(laterTodayDelayMinutesSelector(state), 'minutes'),
    },
    now.hour() < 16 && {
      text: l.thisEvening,
      icon: 'moon-o',
      resolve: () => dayjs().startOf('day').add(startEveningsAtSelector(state), 'minutes'),
    },
    {
      text: l.tomorrow,
      icon: 'sun-o',
      resolve: () => dayjs().startOf('day').add(1, 'day').add(startMorningsAtSelector(state), 'minutes'),
    },
    now.hour() > 15 && {
      text: l.tomorrowEvening,
      icon: 'moon-o',
      resolve: () => dayjs().startOf('day').add(1, 'day').add(startEveningsAtSelector(state), 'minutes'),
    },
    (now.day() <= 5 && now.day() > 0 && now.day() !== 4) && {
      text: `${now.add(2, 'days').format('dddd')}`,
      icon: 'paper-plane',
      resolve: () => dayjs().startOf('day').add(2, 'days').add(startMorningsAtSelector(state), 'minutes'),
    },
    now.day() < 5 && now.day() > 0 && {
      text: l.thisWeekend,
      icon: 'glass',
      resolve: () => dayjs()
        .day(6)
        .startOf('day')
        .add(startMorningsAtSelector(state), 'minutes'),
    },
    {
      text: l.nextWeek,
      icon: 'briefcase',
      resolve: () => dayjs()
        .add(1, 'week')
        .day(1)
        .startOf('day')
        .add(startMorningsAtSelector(state), 'minutes'),
    },
    (now.day() >= 5 || now.day() === 0) && {
      text: l.nextWeekend,
      icon: 'glass',
      resolve: () => dayjs()
        .add(1, 'week')
        .day(6)
        .startOf('day')
        .add(startMorningsAtSelector(state), 'minutes'),
    },
    {
      text: l.inOneMonth,
      icon: 'calendar',
      resolve: () => dayjs()
        .add(1, 'month')
        .startOf('day')
        .add(startMorningsAtSelector(state), 'minutes'),
    },
  ]);

  return !lastPostponedDate
    || entries.find((e) => e.resolve && e.resolve().valueOf() === lastPostponedDate.valueOf())
    || lastPostponedDate.valueOf() <= now.valueOf()
    ? entries
    : [...entries, {
      text: lastPostponedDate.calendar(),
      icon: 'redo-variant',
      iconSet: 'MaterialCommunityIcons',
      resolve: () => lastPostponedDate,
    }];
};
